/* eslint-disable no-lone-blocks */
/**
 * @file paddle hack partner
 * @author wanzhongyun
 */

import React from 'react';
import { PaddleHackathonPartnerType } from './../../type';

import './style.less';


const HackPartner = (props: PaddleHackathonPartnerType) => {

    const {
        titleImageUrl,
        content
    } = props;

    return (
        <div className='paddle-hack-partner-wrapper'>
            <img className='paddle-hack-partner-title' src={titleImageUrl} alt='' />
            <div className='paddle-hack-partner-content'>

                {(content ? content : []).map((contentImgValue: any) => {
                    return (<div className='paddle-hack-partner-contentImg'>
                        <div className='paddle-hack-partner-contentImg-left'>{contentImgValue.title}</div>
                        <div className='paddle-hack-partner-contentImg-right'>
                            {
                                (contentImgValue?.partnerList ? contentImgValue.partnerList : []).map((imgContent: any) => {

                                    {
                                        if (contentImgValue.partnerList.indexOf(imgContent) > 4){
                                            return (<a className='paddle-hack-partner-contentImg-right-a move_a' href={imgContent.detailLink} target='_blank' rel='noreferrer'>
                                                <img className='paddle-hack-partner-contentImg-rightImg ' src={imgContent.partnerList} alt="" />
                                            </a>)
                                        } else {
                                            return (<a className='paddle-hack-partner-contentImg-right-a' href={imgContent.detailLink} target='_blank' rel='noreferrer'>
                                                <img className='paddle-hack-partner-contentImg-rightImg ' src={imgContent.partnerList} alt="" />
                                            </a>)
                                        }
                                    }
                                })
                            }
                        </div>
                    </div>)
                })}
            </div>
        </div>
    );
};

export default HackPartner;